import ContactTile from "@gik/contact/components/ContactTile/ContactTile";
import { translationKeys } from "@gik/contact/i18n/en";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { HTMLParser } from "@gik/ui-legacy/HTMLParser";
import React from "react";
import { useTranslation } from "react-i18next";

export default function PressInquiries() {
	const bem = useBemCN("press-inquiries");
	const { t } = useTranslation();

	const email = "press@giveinkind.com";

	return (
		<ContactTile
			{...bem()}
			title={t(translationKeys.PressInquiriesTitle)}
			buttonText={t(translationKeys.PressInquiriesButtonText)}
			buttonLink="https://create.giveinkind.com/press/"
		>
			<HTMLParser
				rawHtml={t(translationKeys.PressInquiriesContent, { email })}
			/>
		</ContactTile>
	);
}
